import { checkShouldUseMocks } from '../envUtils';

export const API = {
    URL_LOGIN_AUTH: '/ajax/{segment}/login/auth',
    URL_MSIGN_AUTH: '/ajax/{segment}/login/isign',
    URL_MSIGN_AUTH_STATUS: '/ajax/{segment}/login/isign/status',
    URL_MSIGN_AUTH_CANCEL: '/ajax/{segment}/login/isign/cancel',
    URL_SMART_ID_AUTH: '/ajax/{segment}/login/smartid',
    URL_SMART_ID_AUTH_STATUS: '/ajax/{segment}/login/smartid/status',
    URL_SMART_ID_AUTH_CANCEL: '/ajax/{segment}/login/smartid/cancel',
    URL_RESET_PASSWORD: '/ajax/{segment}/remind-password',
    URL_REGISTER_USER: '/ajax/register/new',
    URL_CREATE_PASSWORD: '/ajax/register/confirm',
    URL_VALIDATE_TOKEN: '/ajax/register/validate',
    URL_AUTH_TOKEN: '/ajax/{segment}/user/token',
    URL_PASETO_AUTH_TOKEN_B2C: '/ajax/b2c/user/token/paseto',
    URL_PASETO_AUTH_TOKEN_B2B: '/ajax/b2b/user/token/paseto/{agreementId}',
    URL_PASETO_AUTH_TOKEN_ANONYMOUS_ESHOP: '/ajax/{segment}/user/token/paseto/anonymous/{cartGuid}',
    URL_CONFIRM_USER_DATA: '/ajax/{segment}/login/bank/check',
    URL_LOGIN_CONFIRM_2FA: '/ajax/{segment}/login/auth/code',
    URL_RESEND_2FA_CODE: '/ajax/{segment}/login/code',
    URL_CONFIRM_PHONE_NUMBER: '/ajax/{segment}/login/code/number',
    URL_CSRF_TOKEN: '/ajax/user/csrf-token',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_LOGIN_AUTH = '/api/ajax/login/auth';
    API.URL_MSIGN_AUTH = '/api/ajax/login/isign';
    API.URL_MSIGN_AUTH_STATUS = '/api/ajax/login/isign-status';
    API.URL_MSIGN_AUTH_CANCEL = '/api/ajax/login/isign-cancel';
    API.URL_SMART_ID_AUTH = '/api/ajax/login/isign';
    API.URL_SMART_ID_AUTH_STATUS = '/api/ajax/login/isign-status-error';
    API.URL_SMART_ID_AUTH_CANCEL = '/api/ajax/login/isign-cancel';
    API.URL_RESET_PASSWORD = '/api/ajax/remind-password';
    API.URL_CREATE_PASSWORD = '/api/ajax/register/confirm';
    API.URL_REGISTER_USER = '/api/ajax/register/new';
    API.URL_VALIDATE_TOKEN = '/api/ajax/register/validate';
    API.URL_AUTH_TOKEN = '/api/ajax/user/token';
    API.URL_PASETO_AUTH_TOKEN_B2C = '/api/ajax/user/paseto-token';
    API.URL_PASETO_AUTH_TOKEN_B2B = '/api/ajax/user/paseto-token';
    API.URL_PASETO_AUTH_TOKEN_ANONYMOUS_ESHOP = '/api/ajax/user/paseto-token';
    API.URL_CONFIRM_USER_DATA = '/api/ajax/login/auth';
    API.URL_LOGIN_CONFIRM_2FA = '/api/ajax/login/2fa';
    API.URL_RESEND_2FA_CODE = '/api/ajax/login/resend-2fa';
    API.URL_CONFIRM_PHONE_NUMBER = '/api/ajax/login/confirm-phone-number';
    API.URL_CSRF_TOKEN = '/api/ajax/user/csrf-token';
}

export const B2B_AGREEMENT_ID_STORAGE_KEY = 'B2B_AGREEMENT_ID';
export const B2B_AGREEMENT_ID_PLACEHOLDER = 'klientas';
